import React from 'react';

import WithConfiguration from '@domain/layout/with-configuration';

import { ExternalElearningFlowProvider } from './eel-flow-context';

interface ExternalElearningLayoutProps {
  children: React.ReactNode;
}

function ExternalElearningLayout({ children }: ExternalElearningLayoutProps) {
  return (
    <WithConfiguration>
      <ExternalElearningFlowProvider>{children}</ExternalElearningFlowProvider>
    </WithConfiguration>
  );
}

export default ExternalElearningLayout;
